var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDoubleDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08904 2.16096C2.83276 1.90468 2.41724 1.90468 2.16096 2.16096C1.90468 2.41724 1.90468 2.83276 2.16096 3.08904L6.53596 7.46404C6.79224 7.72032 7.20776 7.72032 7.46404 7.46404L11.839 3.08904C12.0953 2.83276 12.0953 2.41724 11.839 2.16096C11.5828 1.90468 11.1672 1.90468 10.911 2.16096L7 6.07192L3.08904 2.16096ZM3.08904 6.53596C2.83276 6.27968 2.41724 6.27968 2.16096 6.53596C1.90468 6.79224 1.90468 7.20776 2.16096 7.46404L6.53596 11.839C6.79224 12.0953 7.20776 12.0953 7.46404 11.839L11.839 7.46404C12.0953 7.20776 12.0953 6.79224 11.839 6.53596C11.5828 6.27968 11.1672 6.27968 10.911 6.53596L7 10.4469L3.08904 6.53596Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDoubleDown);
export default __webpack_public_path__ + "static/media/CaretDoubleDown.3b60fabdf3f7da6591f4b877164372c1.svg";
export { ForwardRef as ReactComponent };